<template>
  <b-modal
    v-model="showModal"
    ref="modal"
    centered
    size="xl"
    class="alert-modal"
    hide-header-close
    content-class="modal-register"
    footer-class="pt-0 border-0"
    body-class="container-return-invoice"
    @hide="hide"
  >
    <template #modal-header>
      <div class="d-flex w-100 align-items-center">
        <div class="modal-title">ยกเลิกบางรายการ</div>
      </div>
    </template>
    <div>
      <b-row no-gutters style="column-gap: 15px">
        <b-col cols="12" lg="2">
          <div class="panel-select-invoice p-3">
            <b>เลือกสินค้า</b>
            <div class="p-2">
              <div>รายละเอียดสินค้า</div>
              <div>Description</div>

              <div class="panel-invoice" v-if="transaction.product.length > 0">
                <template v-for="(product, index) in transaction.product">
                  <div
                    :key="index"
                    class="items-invoice"
                    v-if="isListProduct(product)"
                    @click="addProducts(product)"
                  >
                    <div>
                      <b>{{ product.barcode }}</b>
                    </div>
                    <div class="text-style">{{ product.name }}</div>
                    <p class="text-style" v-if="product.serial">
                      Serial: {{ product.serial }}
                    </p>
                    <div
                      v-if="product.product_group_barcode_detail"
                      class="text-style"
                    >
                      Group Barcode:
                      {{ product.product_group_barcode_detail }}
                      {{ product.gp_rate }}%
                    </div>
                    <div
                      class="text-style"
                      v-if="product.article_type == 'ZGOLD'"
                    >
                      น้ำหนัก :
                      <span>{{ product.weight | numeral("0,0.00") }} </span>
                    </div>
                    <div class="icon-add" @click="addProducts(product)">
                      <font-awesome-icon
                        icon="chevron-right"
                      ></font-awesome-icon>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="p-3">
          <div class="product-panel">
            <div><b>คืนสินค้า</b></div>
            <table class="w-100 product-return-table">
              <thead>
                <th>
                  รายละเอียดสินค้า
                  <div>Description</div>
                </th>
                <th>
                  จำนวนที่คืน
                  <div>Return Quantity</div>
                </th>
                <th>
                  จำนวนทั้งหมด
                  <div>Total Quantity</div>
                </th>
                <th>
                  ราคา
                  <div>Price</div>
                </th>
                <th>
                  ราคาสุทธิ
                  <div>Net Price</div>
                </th>
                <th>
                  คลัง
                  <div>Inventory</div>
                </th>
                <th></th>
              </thead>
              <tbody v-if="form.products.length > 0">
                <tr
                  v-for="(product, index) in form.products"
                  :key="'bill-' + index"
                >
                  <td>
                    <div>
                      <p>
                        <b>{{ product.barcode }}</b>
                      </p>

                      <p class="product-info">
                        {{ product.name }}
                      </p>

                      <p v-if="product.serial" class="product-info">
                        Serial: {{ product.serial }}
                      </p>
                      <p
                        v-if="product.product_group_barcode_detail"
                        class="product-info"
                      >
                        Group Barcode:
                        {{ product.product_group_barcode_detail }}
                        ({{ product.gp_rate }}%)
                      </p>
                      <p
                        class="product-info"
                        v-if="product.article_type == 'ZGOLD'"
                      >
                        น้ำหนัก :
                        <span>{{ product.weight | numeral("0,0.00") }} </span>
                      </p>
                      <p v-if="product.promotion" class="product-info">
                        <span>
                          โปรโมชั่น:
                          {{
                            !product.promotion || product.promotion.length == 0
                              ? "-"
                              : ""
                          }}</span
                        >
                        <span
                          v-for="(promotion, index2) in product.promotion"
                          :key="index2"
                        >
                          {{ promotion.name }} ลด
                          {{ promotion.discount_value }}
                          <template
                            v-if="index2 != product.promotion.length - 1"
                          >
                            ,
                          </template>
                        </span>
                      </p>
                    </div>
                  </td>
                  <td>
                    <InputText
                      v-model="product.q"
                      class="text-center"
                      type="number"
                      @input="
                        (val, e) => checkMax(index, product.current_quantity, e)
                      "
                      :isValidate="$v.form.products.$each.$iter[index].q.$error"
                      :v="$v.form.products.$each.$iter[index].q"
                      :disabled="product.serial_id != 0"
                    >
                    </InputText>
                  </td>
                  <td>
                    {{ product.quantity }}&nbsp;
                    <span
                      class="text-primary"
                      v-if="
                        product.current_quantity != product.quantity &&
                        product.serial_id == 0
                      "
                    >
                      ({{ product.current_quantity }})
                    </span>
                  </td>
                  <td>
                    <div>
                      {{ product.sap_price | numeral("0,0.00") }}

                      <span
                        v-if="product.sap_price != product.price"
                        class="normal-unit-price"
                      >
                        {{ product.price | numeral("0,0.00") }}
                      </span>
                    </div>
                  </td>
                  <td>
                    {{ product.after_discount_price | numeral("0,0.00") }}
                  </td>
                  <td>
                    <b-form-checkbox
                      v-model="product.is_return_inventory"
                      :value="1"
                      :unchecked-value="0"
                      :disabled="
                        form.is_return_product_inventory == 1 ||
                        product.stock_type_id.length == 0
                      "
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <font-awesome-icon
                      icon="trash-alt"
                      class="pointer"
                      @click="removeReturnProduct(index)"
                    ></font-awesome-icon>
                  </td>
                </tr>
              </tbody>
              <template v-else>
                <tr>
                  <td colspan="6" class="text-center empty-row">
                    กรุณาเลือกสินค้า
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </b-col>
      </b-row>
    </div>

    <template #modal-footer="{ hide }">
      <div
        class="d-flex flex-wrap justify-content-md-between w-100 my-0 align-items-center mt-3"
      >
        <div
          class="d-flex align-items-center flex-md-nowrap flex-wrap"
          style="column-gap: 15px; row-gap: 15px"
        >
          <div
            class="d-flex align-items-center"
            v-if="returnSetting.enable == 1"
          >
            <b-form-checkbox
              v-model="form.is_return_product_inventory"
              :value="1"
              :unchecked-value="0"
              @change="returnStock"
            >
              Transfer
            </b-form-checkbox>
            <InputText
              class="ml-2"
              disabled
              :value="
                form.is_return_product_inventory == 1
                  ? returnSetting.inventory_transfer_form_name
                  : ''
              "
            />
          </div>
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-model="form.is_return_store_credit"
              :value="1"
              :unchecked-value="0"
            >
              Store Credit
            </b-form-checkbox>

            <InputText disabled :value="storeCredit" class="ml-2" />
          </div>
          <div class="d-flex align-items-center">
            <InputText
              textFloat=""
              v-model="form.sale_id"
              ref="saleIdInput"
              :disabled="isLockSaleId"
              placeholder="รหัสพนักงาน"
              :v="$v.form.sale_id"
              :isValidate="$v.form.sale_id.$error"
              type="text"
              @input="getSale"
              id="myInput"
            >
              <template v-slot:input-wrapper>
                <div class="sale-autofill" v-show="saleName" id="floating">
                  : {{ saleName }}
                </div>
              </template>
            </InputText>
          </div>
        </div>
        <div class="my-0 mt-3 mt-md-0">
          <b-button
            variant="close"
            class="btn-modal btn-hover mr-1"
            @click="hide('forget')"
            :disabled="isLoading"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover ml-1"
            @click="submit"
          >
            ยืนยัน
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
let controller = null;
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import minValue from "vuelidate/lib/validators/minValue";
export default {
  props: {
    transaction: {
      type: Object,
      default: () => ({}),
    },
  },
  validations() {
    return {
      form: {
        sale_id: {
          required,
        },
        products: {
          required,
          $each: {
            q: {
              required,
              minValue: minValue(1),
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
      require_pin_login: "getRequirePin",
    }),
    storeCredit() {
      if (this.form.is_return_store_credit == 0) return "";
      // console.log(this.);
      let sum = this.form.products
        .map((el) => el.q * (el.after_discount_price / el.quantity))
        .reduce((a, b) => a + b, 0);
      return sum.toFixed(2);
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      billingList: [],
      limit: 0,
      isSelectBilling: false,
      form: {
        transaction_id: "",
        invoice_no: "",
        grand_total: "",
        sale_id: "",
        branch_id: "",
        is_return_inventory: 0,
        is_return_store_credit: 0,
        is_return_product_inventory: 0,
        stock_type_id: 0,
        products: [],
      },
      isLockSaleId: false,
      saleName: "",
      returnSetting: { inventory_transfer_form_name: "", enable: 0 },
    };
  },
  methods: {
    checkMax(val, max, e) {
      if (e.target.value > max) {
        e.target.value = max;

        this.$nextTick(() => (this.form.products[val].q = max));
        e.preventDefault();
      }
    },
    async show() {
      this.getReturn();
      this.showModal = true;
      this.form.branch_id = this.branchId;
      this.form.invoice_no = this.transaction.invoice_no;
      this.form.grand_total = this.transaction.grand_total;
      this.form.transaction_id = this.transaction.id;
      this.form.is_return_product_inventory = 0;
      let getSaleId = this.$cookies.get("saleId");

      if (getSaleId && this.require_pin_login == "1") {
        this.form.sale_id = getSaleId;
        this.isLockSaleId = true;
      }
      this.getSale();
    },
    hide() {
      this.showModal = false;
      this.form = {
        transaction_id: "",
        invoice_no: "",
        grand_total: "",
        sale_id: "",
        branch_id: "",
        is_return_inventory: 0,
        is_return_store_credit: 0,
        is_return_product_inventory: 0,
        stock_type_id: 0,
        products: [],
      };
    },
    async submit() {
      this.$v.$touch();

      if (this.$v.$error) return;
      this.confirmAlert(
        `หากทำรายการนี้ไปแล้ว จะไม่สามารถยกเลิกได้`,
        "คุณต้องการยืนยันหรือไม่ ?"
      ).then(async ({ isConfirmed }) => {
        if (isConfirmed) {
          let payload = { ...this.form };
          // return console.log(payload.products);
          function transformProducts(products) {
            const result = [];

            products.forEach((product) => {
              let quantity = product.q;
              if (product.stock_type_id.length == 0)
                result.push({
                  ...product,
                  quantity: quantity,
                  q: quantity,
                  stock_type_id: 0,
                });
              else
                product.stock_type_id.forEach((stockType, index) => {
                  let remain_stock = product.stock_type_name[index].stock;
                  let a = quantity >= remain_stock ? remain_stock : quantity;
                  result.push({
                    ...product,
                    quantity: a < 0 ? 0 : a,
                    q: a < 0 ? 0 : a,
                    stock_type_id: stockType,
                  });

                  quantity = quantity - remain_stock;
                });
            });

            return result;
          }
          payload.products = transformProducts(payload.products);
          // return console.log(payload.products);
          // return console.log(payload);
          await this.$store.dispatch("setMainLoading", true);

          const res = await this.axios.post(
            `${this.$baseUrl}/transaction/partial_return`,
            payload
          );
          await this.$store.dispatch("setMainLoading", false);
          if (res.result == 1) {
            await this.successAlert();
            this.$emit("success", this.form.transaction_id);
            this.hide();
          } else {
            this.errorAlert(res.message);
          }
        }
      });
    },
    addProducts(items) {
      items.q = 1;
      items.is_return_inventory =
        items.stock_type_id.length == 0
          ? 0
          : this.form.is_return_product_inventory;
      let temp = JSON.parse(JSON.stringify(items));
      this.form.products.push(temp);
    },
    removeReturnProduct(index) {
      this.form.products.splice(index, 1);
    },
    isListProduct(product) {
      if (product.current_quantity == 0) return false;
      let check = this.form.products.find(
        (el) =>
          el.product_id == product.product_id &&
          el.serial_id == product.serial_id
      );

      return check ? false : true;
    },
    async getReturn(id) {
      const data = await this.axios(
        `${this.$baseUrl}/transaction/Setting/ReturnProductTransfer`
      );
      if (data.detail) {
        this.form.is_return_product_inventory = data.detail.enable;

        this.returnSetting = data.detail;
      }
    },
    async getSale(value) {
      // let value = e.target.value;
      this.saleName = null;
      if (controller) {
        controller.cancel("Request ถูกยกเลิก");
        clearTimeout(this.timeout);
      }

      controller = this.$axios.CancelToken.source();

      this.timeout = setTimeout(async () => {
        await this.$axios(
          `${this.$baseUrl}/sales/getSalesName/${this.form.sale_id}`,
          {
            cancelToken: controller.token,
          }
        )
          .then((data) => {
            this.updatePosition();
            this.saleName = data.detail;
          })
          .catch((error) => {
            if (this.$axios.isCancel(error)) {
              console.log("ถูกยกเลิก request");
            } else if (error.name === "CanceledError") {
              console.log("ถูก abort โดย user");
            } else {
              console.error("เกิด error:", error);
            }
          });
      }, 1000);
    },
    updatePosition() {
      const input = document.getElementById("myInput");
      const floating = document.getElementById("floating");

      const span = document.createElement("span");
      span.style.visibility = "hidden";
      span.style.position = "absolute";
      span.style.whiteSpace = "pre";
      span.style.font = getComputedStyle(input).font;
      span.textContent = input.value;
      document.body.appendChild(span);
      const width = span.offsetWidth + 15;
      document.body.removeChild(span);
      floating.style.left = width + "px";
    },
    returnStock(value) {
      if (value == 1)
        this.form.products = this.form.products.map((el) => {
          return { ...el, is_return_inventory: value };
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-invoice {
  min-height: 85px;
  position: relative;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  border: 1px solid whitesmoke;
  /* align-items: center; */
  /* justify-content: center; */
  &.add {
    border: 1px dashed var(--primary-color);
    color: var(--primary-color);
  }
  &.is-default {
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
  }
}
.panel-invoice {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-top: 1rem;
}
.panel-action {
  position: absolute;
  top: 10%;
  right: 3%;
  display: flex;
  align-items: center;
  column-gap: 10px;
}
.box-default {
  color: white;
  background-color: green;
  border: 1px solid green;
  border-radius: 0.3rem;

  font-size: 12px;
  padding: 0 5px;
}
.modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
.panel-select-invoice {
  background: #e5e5e5;
  padding-inline: 0.5rem;
  height: 650px;
  overflow: hidden auto;
  // color: #f3f3f3;
}
::v-deep .modal-body {
  padding: 0;
}
.items-invoice {
  background-color: #f3f3f3;
  border-radius: 0.3rem;
  padding: 0.5rem 1rem;

  width: 100%;
  position: relative;
  cursor: pointer;
  .icon-add {
    position: absolute;
    top: 0.35rem;
    right: 0.35rem;

    // padding: 0.25rem 0.5rem;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--primary-color);
    svg {
      color: var(--font-primary-color);
      font-size: 12px;
    }
  }
}
::v-deep .container-return-invoice {
  height: 650px;
  max-height: 650px;
  overflow: auto;
}
.product-panel {
  max-height: 650px;
  overflow: auto;
  width: 100%;
  // display: flex;
  // flex-wrap: wrap;
}
.product-list {
  max-height: 650px;
  // overflow: auto;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.text-style {
  font-size: 12px;
  color: #707070 !important;
  width: calc(100% - 30px);
}
.product-info {
  font-size: 12px;
}
.price {
  background: #e5e5e5;
  padding: 0.25rem;
}
@media screen and (max-width: 768px) {
  .header-products {
    flex-wrap: nowrap;
    // overflow: auto;
  }
  .header-products-item {
    max-width: 200px;
  }
  .panel-select-invoice {
    height: auto;
  }
  .price {
    // width: 150px;
    max-width: 200px;
  }
  .product-panel {
    overflow: auto;
  }
  td:first-child,
  th:first-child {
    width: 450px;
  }
}
.normal-unit-price {
  text-decoration: line-through;
}
.no-data {
  background-color: #e5e5e5;
  padding: 1rem;
  text-align: center;
  border-radius: 0;
  margin: 1rem 0;
}
.current-quantity {
  position: absolute;
  bottom: 3%;
  left: 2%;
  font-size: 12px;
}
.product-return-table {
  border-spacing: 0 10px;
  border-collapse: separate;
  thead {
    background-color: white !important;
    color: black !important;
  }

  td {
    border: unset !important;
    align-content: center;
  }
  td,
  th {
    padding: 0.7rem 1rem !important;
  }
  th:not(:first-child),
  td:not(:first-child) {
    text-align: center;
  }
  th:nth-child(2),
  td:nth-child(2) {
    max-width: 115px;
  }
  td:first-child,
  th:first-child {
    width: 450px;
  }
  td:first-child {
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem;
  }
  td:nth-last-child(2) {
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }
  td:not(:last-child) {
    background-color: #e5e5e5;
  }
  .empty-row {
    background-color: #e5e5e5;
    padding: 1rem !important;
  }
}
@media screen and (max-width: 1720px) {
  td:first-child,
  th:first-child {
    width: 250px !important;
  }
}
.sale-autofill {
  position: absolute;
  top: 50%;
  left: 40%;
  color: rgb(189, 189, 189);
  // font-size: 12px;
  transform: translateY(-50%);
}
</style>
